export enum SelectionRuleCategory {
	JOB_FULFILLMENT_RULE = 'JOB_FULFILLMENT_RULE',
	'3PL_SELECTION_RULE' = '3PL_SELECTION_RULE',
	'3PL_DRIVER_SELECTION_RULE' = '3PL_DRIVER_SELECTION_RULE',
	DRIVER_SELECTION_RULE = 'DRIVER_SELECTION_RULE'
}

export const SelectionRuleCategoryLables: { [key: string]: string } = {
	JOB_FULFILLMENT_RULE: 'Job Fulfillment Rule',
	'3PL_SELECTION_RULE': '3PL Selection Rule',
	'3PL_DRIVER_SELECTION_RULE': '3PL Driver Selection Rule',
	DRIVER_SELECTION_RULE: 'Driver Selection Rule'
}

export const ruleTypeOptions = [
	{
		label: SelectionRuleCategoryLables.JOB_FULFILLMENT_RULE,
		value: SelectionRuleCategory.JOB_FULFILLMENT_RULE
	},
	{
		label: SelectionRuleCategoryLables.DRIVER_SELECTION_RULE,
		value: SelectionRuleCategory.DRIVER_SELECTION_RULE
	},
	{
		label: SelectionRuleCategoryLables['3PL_SELECTION_RULE'],
		value: SelectionRuleCategory["3PL_SELECTION_RULE"]
	},
	{
		label: SelectionRuleCategoryLables['3PL_DRIVER_SELECTION_RULE'],
		value: SelectionRuleCategory['3PL_DRIVER_SELECTION_RULE']
	}	
];

export enum RuleTrigger {
	DISTANCE_FROM_LOCATION = 'DISTANCE_FROM_LOCATION',
	TIER = 'TIER',
	SUPPLIER_RATING = 'SUPPLIER_RATING',
	CSI_RATING = 'CSI_RATING',
	SKILL = 'SKILL'
}

export const ruleTriggerOptions = {
	[SelectionRuleCategory.JOB_FULFILLMENT_RULE]: [
		{
			label: "Distance from location",
			value: RuleTrigger.DISTANCE_FROM_LOCATION
		}
	],
	[SelectionRuleCategory["3PL_SELECTION_RULE"]]: [
		{
			label: "Distance from location",
			value: RuleTrigger.DISTANCE_FROM_LOCATION
		},
		{
			label: "Tier",
			value: RuleTrigger.TIER
		},
		// {
		// 	label: "Supplier rating",
		// 	value: RuleTrigger.SUPPLIER_RATING
		// }
	],
	[SelectionRuleCategory['3PL_DRIVER_SELECTION_RULE']]: [
		{
			label: "Distance from location",
			value: RuleTrigger.DISTANCE_FROM_LOCATION
		},
		{
			label: "Skill",
			value: RuleTrigger.SKILL
		},
		// {
		// 	label: "CSI rating",
		// 	value: RuleTrigger.CSI_RATING
		// }
	],
	[SelectionRuleCategory.DRIVER_SELECTION_RULE]: [
		{
			label: "Distance from location",
			value: RuleTrigger.DISTANCE_FROM_LOCATION
		}
	]
};

export enum Operator {
	GREATER_THAN = 'GREATER_THAN',
	LESS_THAN = 'LESS_THAN',
}

export const operatorOptions = [
	{ label: "Greater Than", value: Operator.GREATER_THAN },
	{ label: "Less Than", value: Operator.LESS_THAN },
]

export enum FulfillmentType {
	INTERNAL_DRIVER = 'INTERNAL_DRIVER',
	'3PL_AGENCY' = '3PL_AGENCY'
}

export const fulfillmentTypeOptions = [
	{ label: "Internal Driver", value: FulfillmentType.INTERNAL_DRIVER },
	{ label: "3PL Agency", value: FulfillmentType["3PL_AGENCY"] },
]

export enum PartnerSkills {
	DEMO_CAR_DELIVERY = "Demo Car Delivery",
	NEW_CAR_DELIVERY = "New Car Delivery",
	COURTESY_CAR_DELIVERY = "Courtesy Car Delivery",
}

export const skillOptions = [
	{ label: PartnerSkills.DEMO_CAR_DELIVERY, value: PartnerSkills.DEMO_CAR_DELIVERY },
	{ label: PartnerSkills.NEW_CAR_DELIVERY, value: PartnerSkills.NEW_CAR_DELIVERY },
	{ label: PartnerSkills.COURTESY_CAR_DELIVERY, value: PartnerSkills.COURTESY_CAR_DELIVERY },
]

export const labels: { [key: string]: string } = {
	[RuleTrigger.DISTANCE_FROM_LOCATION]: "Distance from location",
	[RuleTrigger.TIER]: "Tier",
	[RuleTrigger.SUPPLIER_RATING]: "Supplier rating",
	[RuleTrigger.SKILL]: "Skill",
	[RuleTrigger.CSI_RATING]: "CSI rating",
	[FulfillmentType.INTERNAL_DRIVER]: "Internal Driver",
	[FulfillmentType["3PL_AGENCY"]]: "3PL Agency"
}

export interface IGetSingleEntityParams {
	id?: string;
	tenantId?: string;
	organisationId?: string;
	branchId?: string;
	createdAt?: string;
	updatedAt?: string;
}

export interface IRuleItem {
	ruleName: string;
	sequence: number;
	value?: string;
	operator?: string;
	distanceInKm?: number;
}

export enum ALLOCATION_RULE_CATEGORY {
	RENTAL = "RENTAL",
	SUBSCRIPTION = "SUBSCRIPTION",
	TEST_DRIVE = "TEST_DRIVE",
	COURTESY_CAR = "COURTESY_CAR",
	SERVICE = "SERVICE",
	DEFLEET = "DEFLEET",
	BRANCH_TRANSFER = "BRANCH_TRANSFER"
}

export const allocationRuleCategoryLabels = {
	[ALLOCATION_RULE_CATEGORY.RENTAL]: "Rental",
	[ALLOCATION_RULE_CATEGORY.SUBSCRIPTION]: "Subscription",
	[ALLOCATION_RULE_CATEGORY.TEST_DRIVE]: "Test Drive",
	[ALLOCATION_RULE_CATEGORY.COURTESY_CAR]: "Courtesy Car",
	[ALLOCATION_RULE_CATEGORY.SERVICE]: "Service",
	[ALLOCATION_RULE_CATEGORY.DEFLEET]: "De-Fleet",
	[ALLOCATION_RULE_CATEGORY.BRANCH_TRANSFER]: "Branch Transfer"
};

export interface IAllocationRule extends IGetSingleEntityParams {
	category: ALLOCATION_RULE_CATEGORY;
	allocationRules: IAllocationCategoryRule[];
}

export interface IAllocationCategoryRule {
	ruleCategory: SelectionRuleCategory;
	rules: IRuleItem[];
	priority: number;
	isActive: boolean;
}

const commonAllocationRules = [
	{
		ruleCategory: SelectionRuleCategory.JOB_FULFILLMENT_RULE,
		priority: 1,
		rules: [],
		isActive: true,
	},
	{
		ruleCategory: SelectionRuleCategory['3PL_SELECTION_RULE'],
		priority: 2,
		rules: [],
		isActive: true,
	},
	{
		ruleCategory: SelectionRuleCategory.DRIVER_SELECTION_RULE,
		priority: 3,
		rules: [],
		isActive: true,
	},
	{
		ruleCategory: SelectionRuleCategory['3PL_DRIVER_SELECTION_RULE'],
		priority: 4,
		rules: [],
		isActive: true,
	}
];

export const defaultAllocationRules: IAllocationRule[] = Object.values(ALLOCATION_RULE_CATEGORY).map(
	(category) => ({
		category: category,
		allocationRules: [...commonAllocationRules],
	})
);

export function updateAllocationRules(
	filteredRules: IAllocationRule[],
	activeTypesArray: ALLOCATION_RULE_CATEGORY[],
	isSupplierPortalEnabled: boolean
): IAllocationRule[] {
	const filteredRulesMap = new Map(
		filteredRules.map(rule => [rule.category, rule])
	);
	const defaultRulesMap = new Map(
		defaultAllocationRules.map(rule => [rule.category, rule])
	);
	const updatedRules: IAllocationRule[] = [];

	for (const category of activeTypesArray) {
		let rule = filteredRulesMap.get(category) ?? defaultRulesMap.get(category);

		if (rule) {
			let updatedRule = { ...rule, allocationRules: [...rule.allocationRules] };
			const defaultRule = defaultRulesMap.get(category);

			if (defaultRule) {
				for (const defaultRuleCategory of defaultRule.allocationRules) {
					const existingCategory = updatedRule.allocationRules.find(
						r => r.ruleCategory === defaultRuleCategory.ruleCategory
					);

					if (!existingCategory) {
						updatedRule.allocationRules.push({ ...defaultRuleCategory });
					}
				}
			}
			updatedRule.allocationRules = updatedRule.allocationRules.sort((a, b) => a.priority - b.priority)
			if (!isSupplierPortalEnabled) {
        updatedRule.allocationRules = updatedRule.allocationRules.filter(
          rule => rule.ruleCategory === SelectionRuleCategory.DRIVER_SELECTION_RULE
        );
      }
			updatedRules.push(updatedRule);
		}
	}
	return updatedRules;
}

export const ruleDescriptions = {
	[SelectionRuleCategory.JOB_FULFILLMENT_RULE]: "Determines whether a job is assigned to an internal driver or a third-party logistics provider (3PL) based on specific rules. The system evaluates these rules and allocates the job accordingly.",
	[SelectionRuleCategory["3PL_SELECTION_RULE"]]: "If a job is allocated to a 3PL, this rule selects the appropriate provider based on defined rules. The system applies these rules to determine the most suitable 3PL for the job.",
	[SelectionRuleCategory['3PL_DRIVER_SELECTION_RULE']]: "This rule determines which 3PL driver receives the job based on relevant rules. The system evaluates these rules to ensure the best match for the assignment.",
	[SelectionRuleCategory.DRIVER_SELECTION_RULE]: "If a job is assigned to an internal driver, this rule determines which driver receives the job based on relevant rules. The system evaluates these rules to ensure the best match for the assignment."
}